import * as constants from "../../constants";

const initialState = {
    access_token : null,
    offers_data : {
        "coupon_discount": 30,
        "tax_amount": 150,
        "category": "llp",
        "plan_amount":"5999",
        "offers": [
            {
                "name": "Digital Signature Certificate",
                "price": 400,
                "discount_percent": 50,
                "payable_price": 200,
                "offer_type": "digital_signature"
            },
            {
                "name": "PAN Registration",
                "price": 1000,
                "discount_percent": 50,
                "payable_price": 500,
                "offer_type": "pan_registration"
            },
            {
                "name": "TAN Registration",
                "price": 800,
                "discount_percent": 50,
                "payable_price": 400,
                "offer_type": "tan_registration"
            },
            {
                "name": "GST Registration",
                "price": 600,
                "discount_percent": 50,
                "payable_price": 300,
                "offer_type": "gst_registration"
            }
        ]
    },
    step:0,
    razorpay_order_id:null,
    payable_amount:null,
    razorpay_payment_id:null,
    razorpay_signature:null,
    customer_email : null,
    customer_contact_number : null,
    loading:false
}

export default function globals(state = initialState , action) {

    switch (action.type) {
        case constants.SET_ACCESS_TOKEN:
            return {...state, access_token: action.payload}
        case constants.SET_OFFERS_DATA:
            return {...state, offers_data: action.payload}
        case constants.SET_UPDATE_STEP:
            return {...state, step: action.payload}
        case constants.SET_RAZORPAY_ORDER_ID:
            return {...state, razorpay_order_id: action.payload.razorpay_order_id , payable_amount: action.payload.amount}
        case constants.SET_SUCCESSFULL_RAZORPAY_PAYMENT:
            return {...state,
                razorpay_payment_id : action.payload ? action.payload.razorpay_payment_id : null,
                razorpay_signature : action.payload ? action.payload.razorpay_signature : null,
                razorpay_order_id : action.payload ? action.payload.razorpay_order_id : null,
            }
        case constants.SET_CUSTOMER_DATA:
            return {...state,
                customer_email : action.payload ? action.payload.customer_email : null,
                customer_contact_number : action.payload ? action.payload.contact_number : null,
            }
        case constants.SET_DATA_LOADING:
            return {...state,
                loading: action.payload
            }
        default:
            return state

    }
}